export const articleHomeData = {
    featuredArticle: {
        id: 1,
        rubrique: "Géovisualisation",
        auteur: "Nom de l'auteur",
        date: "18 Décembre 2025",
        title: "Titre de l'article en vedette",
        description: "Description de l'article en vedette",
        isNew: true
    },
    secondaryArticles: [
        {
            id: 2,
            rubrique: "Cartographie",
            auteur: "Auteur secondaire 1",
            date: "12 Janvier 2025",
            title: "Titre de l'article secondaire 1",
            description: "Description de l'article secondaire 1"
        },
        {
            id: 3,
            rubrique: "Image satellites",
            auteur: "Auteur secondaire 2",
            date: "15 Février 2025",
            title: "Titre de l'article secondaire 2",
            description: "Description de l'article secondaire 2"
        }
    ],
    buttonText: "En savoir plus",
    backgroundImage: "assets/herobg/search-hero.bg" // Ajout de l'image d'arrière-plan
};